:host {
  display: block;
  padding: 1rem;
}

.features-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  overflow-x: auto;
  background-color: white;
  border-radius: 0.5rem;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
}

.icon-wrapper {
  width: 4rem;
  height: 4rem;
  border-radius: 9999px;
  background-color: white;
  box-shadow: 0 4px 10px rgba(186, 167, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  width: 3rem;
  height: 3rem;
}

.title {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}
.features-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.features-scroll-wrapper::-webkit-scrollbar {
  display: none;
}
